//trial starts here
function showImages()//everything here appears at the same time with the images
{
	var totalNumberOfStimuli = window.stimFieldsMax;

	//need to redefine containers here, in case previous trial was audio/video/words
	//setup target container
	stimContainers[0] = document.getElementById("imageTarget");

	//setup images containers
	for (var i = 1; i <= totalNumberOfStimuli; i++)
	{
		stimContainers[i] = document.getElementById('image'+i);
	}

	//setup mask container
	maskContainer = document.getElementById("mask");


	//hide/show fixation cross
	if (listTrialFixation[trialRow].allTrial || listTrialFixation[trialRow].withStim) {
		//it may be already on screen, but no demage done if we show it again
		showFixation();
	} else {
		hideFixation();
	}

	showTrialInfo();//only displays if selected
	showTimer();//only displays if selected

	// stimContainers[1].style.display="block";//that's a quick fix to work with sounds/movies; rewrite


	//set containers to nonclickable
	for (var i = 1; i <= totalNumberOfStimuli; i++) {
		 stimContainers[i].className="nonclickableImage";
	}

	//CONTENT AND SIZE
		//target size
		stimContainers[0].src = images[0][trialRow].src;
		stimContainers[0].width = trialInfo["target"].width;
		stimContainers[0].height = trialInfo["target"].height;

		//mask size
		maskContainer.src = images[window.imageColumns.length - 1][trialRow].src;
		maskContainer.width = trialInfo["mask"].width;
		maskContainer.height = trialInfo["mask"].height;

		//stimuli sizes
		for (var i = 1; i <= totalNumberOfStimuli; i++)
		{
			var key = "image"  + i;
			stimContainers[i].src = images[i][trialRow].src;
			if (images[i][trialRow].dataset && images[i][trialRow].dataset.stimName) {
				stimContainers[i].dataset.stimName = images[i][trialRow].dataset.stimName;
			}
			stimContainers[i].width = trialInfo[key].width;
			stimContainers[i].height = trialInfo[key].height;
			window.applyStimCssOption(trialRow, i);
			if(!getCursorForCurrentTrial()) {
				stimContainers[i].style.cursor = null;
			} else {
				stimContainers[i].style.cursor = getCursorForCurrentTrial();
			}
		}
		
		if(columnForTrial('stimOptions', trialRow).includes('random')){
			randomizeStimOrder(stimContainers);
		}

		console.log('stimContainers init', stimContainers);
		console.log('many screens? ', trialHasManyScreens(listTrialScreensTimings[trialRow]));

	// FOR SIMULTANEOUS PRESENTATION
	if (!trialHasManyScreens(listTrialScreensTimings[trialRow])) {
		console.log('single screen');

		outsideTopCanvas = Math.min(0, canvasHeight/2 - image1height/2 - spaceTargetImages - imageTargetHeight - borderImage);
		verticalShift = -outsideTopCanvas;

				//// CFPT /////////////////
			if (listArrays[allColumns.indexOf('test')][trialRow]=="CFPT") //for now do these only for CFPT
				{showCFPT();}
			if (listArrays[allColumns.indexOf('test')][trialRow]=="CFPT2") //for now do these only for CFPT
				{showCFPT2();}

			// SHOW TARGET
			if (listArrays[allColumns.indexOf('target')][trialRow]!="na")
					{
						stimContainers[0].style.top = (canvasHeight/2 - image1height/2 - spaceTargetImages - imageTargetHeight - borderImage + verticalShift) + "px";
						stimContainers[0].style.left = (canvasWidth/2 - imageTargetWidth/2) + "px";
						stimContainers[0].style.display="block";
					}


  			window.screenViewStart = performance.now();

			// SHOW TEST
			if (listArrays[allColumns.indexOf('test')][trialRow]!="CFPT" && listArrays[allColumns.indexOf('test')][trialRow]!="CFPT2")
			{
				minImagesTop = showImageTest(listNoStim[trialRow]);
			}

			/// SHOW IMAGES, TEXT, BUTTONS
			// if (listArrays[allColumns.indexOf('fixationStim')][trialRow]!="na"){showFixation();}//show fixation on stimuli

			//TODO enable only on responseWindow
			//showButtons();

			showTrialTextForScreen(trialRow, 0);
			showTrialTextAllStim(trialRow, window.minTrialAllImagesTop);
			showTrialTextAllTrial(trialRow, window.minTrialAllImagesTop);

			displayText("topLeft", replaceVariables(listArrays[allColumns.indexOf('topLeft')][trialRow], undefined, undefined, undefined, 1));
			displayText("topRight", replaceVariables(listArrays[allColumns.indexOf('topRight')][trialRow], undefined, undefined, undefined, 1));

			// FINAL

			timeInMs = performance.now();//record time
			//TODO enable only on responseWindow
			//recordKeys=1;//enable key responses

			/// HIDE IMAGES
			if(!isNaN(listTrialScreensTimings[trialRow][0].presTime) && listArrays[allColumns.indexOf('test')][trialRow]!="CFPT" && columnForTrial('presTime', trialRow) != "na")
			{
				if (listArrays[allColumns.indexOf('mask')][trialRow]!="na")//show mask if any
				{
					eventTimeOutS1 = postpone(function(info) {
						window.recordPresTime(info);
						//self-advancing for learning
						if (columnForTrial('type', trialRow) == "learn") {
							autoAdvance();
						}
						displayMask();
					},listTrialScreensTimings[trialRow][0].presTime, window.lastTs);
					window.lastPresPostponeIndex = eventTimeOutS1;
					// eventTimeOutMask = postpone("hideImages()",Number(listArrays[allColumns.indexOf('presTime')][trialRow])+Number(listArrays[allColumns.indexOf('ISI')][trialRow]));
				}
				else//hide first screen without a mask
				{
					eventTimeOutS1 = postpone(function(info) {
						window.recordPresTime(info);
						hideTargetAndTest();
						// multiple key responses
						var trialOptions = window.listTrialResponseOptions[window.trialRow] || {};
						var shouldRecordMultipleKeys = Boolean(trialOptions.multipleResponses);
						// if we have multiple keys to record and we recorded the maximum required, then we can move to the next trial
						if (shouldRecordMultipleKeys && window.trialKeysPressedCounter >= trialOptions.multipleResponses.max) {
							nextTrialWithKeys(window.keysTrial);
							return;
						}

						// presentation time finished, but did not reach minimum yet, will end once minimum is reached
						if(shouldRecordMultipleKeys){
							trialOptions.multipleResponses.presentationFinished = true;
						}

						enableResponseWindowAfterStim(trialRow);
						hideTextAfterLastStim(trialRow);
						showTrialTextAfterStim(trialRow);
						//self-advancing for learning
						if (columnForTrial('type', trialRow) == "learn") {
							autoAdvance();
						}
					},
					listTrialScreensTimings[trialRow][0].presTime, window.lastTs);
					window.lastPresPostponeIndex = eventTimeOutS1;
				}
			}

			//all events at once as we have only one screen
			enableResponseWindowAtTrialStart(trialRow);
			enableResponseWindowWithStim(trialRow);
			enableResponseWindowLastStim(trialRow);
	}

	//FOR SEQUENTIAL PRESENTATION
	else
	{
		console.log('SEQUENTIAL presentation');

		//responseWindow
		enableResponseWindowAtTrialStart(trialRow);

		// WITH TARGET
		if (listArrays[allColumns.indexOf('target')][trialRow]!="na")
		{
			var targetScreenTimings = listTrialScreensTimings[trialRow][0];

			outsideTopCanvas = Math.min(0, canvasHeight/2 - image1height/2 - spaceTargetImages - imageTargetHeight - borderImage);
			verticalShift = -outsideTopCanvas;

			if (isTargetAlone(trialRow)) {
				var targetPresTime = targetScreenTimings.presTime;
				var targetISI = targetScreenTimings.isi;

				eventTimeOutS1 = postpone(function (info){
					hideImages();
					window.recordPresTime(info);

					eventTimeOutISI = postpone(function (info) {
						window.recordISI(info);
						//remove the first screen timings that was for target
						listTrialScreensTimings[trialRow].shift();
						if (listTrialTexts[trialRow] && listTrialTexts[trialRow].screens && Array.isArray(listTrialTexts[trialRow].screens)) {
							listTrialTexts[trialRow].screens.shift();
						}
						verticalShift = 0;
						displayScreen2();
					}, targetPresTime, window.lastTs);
				}, targetPresTime, window.lastTs);
				window.lastPresPostponeIndex = eventTimeOutS1;
			} else {
				//show the stimuli on the same screen with target
				displayScreen2();
			}
			//24 is the size of one text row
			//TODO adapt 24
			stimContainers[0].style.top = isTargetAlone(trialRow) ? imageTargetTopAlone + "px" :  (canvasHeight/2 - image1height/2 - spaceTargetImages - imageTargetHeight - borderImage + verticalShift - trialTextHeight + 24 ) + "px";
			stimContainers[0].style.left = (canvasWidth/2 - imageTargetWidth/2 - borderImage) + "px";
			stimContainers[0].style.display="block";
		}
		// WITHOUT TARGET
		else {
			verticalShift = 0;
			displayScreen2();
		}

	}
}
